import React from "react";
import propiedad1 from "../assets/aquilaLogo.svg";
import propiedad2 from "../assets/sample_logo.png";
import Spinner from "./Spinner";

function isImageUrl(url) {
  return /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(url);
}

const VehicleTable = ({ data, loading, onChange }) => {
  const renderPropiedad = (propiedad) => {
    const imagenes = {
      Aquila: propiedad1,
      Sixt: propiedad2,
    };

    const imgSrc = imagenes[propiedad];
    return imgSrc ? (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "50%",
          border: "1px solid #E9E9E9",
          width: 28,
          height: 28,
        }}
      >
        <img
          src={imgSrc}
          alt={`Propiedad ${propiedad}`}
          style={{ objectFit: "cover", width: 12 }}
        />
      </div>
    ) : (
      <span>{propiedad || "N/A"}</span>
    );
  };

  return (
    <div className="inter-regular" style={{ marginTop: 44 }}>
      {loading ? (
        <Spinner />
      ) : (
        <div className="max-h-[220px] overflow-y-auto scrollbar-custom">
          <table className="min-w-full bg-white">
            <thead>
              <tr>
                <th className="font-normal text-xs px-4 py-2 border-b text-left text-[#D9D9D9] border-r">
                  Nombre del Vehículo
                </th>
                <th className="font-normal text-xs px-4 py-2 border-b text-left text-[#D9D9D9] border-r">
                  Propiedad
                </th>
                <th className="font-normal text-xs px-4 py-2 border-b text-left text-[#D9D9D9] border-r">
                  Tipo de Vehículo
                </th>
                <th className="font-normal text-xs px-4 py-2 border-b text-left text-[#D9D9D9]">
                  Disponibilidad
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td className="px-4 py-2 border-b text-xs">
                    {row.name} {row.licensePlate}
                  </td>
                  <td className="px-4 py-2 border-b text-xs">
                    {renderPropiedad(row.ownership)}
                  </td>
                  <td className="px-4 py-2 border-b text-xs">
                    {row.vehicleType || "N/A"}
                  </td>
                  <td className="px-4 py-2 border-b text-xs accent-[#BE202F]">
                    <input
                      type="checkbox"
                      value={row.status}
                      defaultChecked={row.status === 1}
                      onClick={() => onChange(rowIndex, row.status)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default VehicleTable;
